import { createContext } from "react";

import { DialogContextValue } from "./types";

/**
 * React Context for dialog state management
 *
 * The DialogContextValue type takes a generic parameter for dialog names.
 * We use `any` here for simplicity in implementing the types internal to
 * the Dialog Manager. Consumers, however, will have type safety in their
 * dialog names since the adjacent useDialogs hook requires a type for
 * DialogNames.
 *
 * This is how Formik handles generic types for React context values,
 * see: https://github.com/jaredpalmer/formik/blob/main/packages/formik/src/FormikContext.tsx
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const DialogContext = createContext<DialogContextValue<any> | undefined>(
  undefined,
);

DialogContext.displayName = "DialogContext";
